/**
 * Returns the key from a KeyboardEvent, normalized across browsers.
 * @deprecated needed like 10 years ago.
 */
export function normalizeArrowKey(event) {
    const { key, keyCode } = event;
    if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
        return `Arrow${key}`;
    }
    return key;
}
//# sourceMappingURL=keyboard.js.map